import {Component, Input} from '@angular/core';


@Component({
    selector: 'ui-label',
    template: `
	    <label class="ui-label">
		    {{label}}
		    <i class="material-icons" *ngIf="hint" matTooltip="hint" >
			    info_outline
		    </i>
	    </label>

    `
})
export class UILabelComponent {
    @Input() hint = '';
    @Input() label;
}
